import { IntegrationProvider } from "@repo/app-types/entities/integration";
import { Loader, LoaderStyle } from "@repo/ui/Loader/loader";
import type { FC } from "react";
import { Navigate } from "react-router";
import { RecordingImportsTab } from "./recordingImportsTab.js";
import { useZoomContactCenterDetailOutletContext } from "./zoomContactCenterIntegrationDetailSection.js";

/**
 * The **Failed imports** tab of the Zoom Contact Center detail: the generic
 * recording-imports surface over the company's Zoom CC integration row.
 */
export const ZoomContactCenterImportsTab: FC = () => {
  const { integration, isLoading } = useZoomContactCenterDetailOutletContext();
  if (!integration) {
    // On a direct visit the integration is still loading; redirecting on that
    // transient `null` would bounce every deep link back to Settings.
    if (isLoading) {
      return <Loader style={LoaderStyle.SPINNER} />;
    }
    // ".." is the parent route: "." would resolve to this child and stay put.
    return <Navigate to=".." replace />;
  }
  return (
    <RecordingImportsTab
      integrationId={integration.id}
      provider={IntegrationProvider.ZOOM_CONTACT_CENTER}
      // A paused integration's rows wait unclaimed, and the API refuses both
      // reprocess and skip (400), so the tab hides the actions instead.
      isPaused={!integration.settings.is_enabled}
      description="Recordings that couldn't be imported from Zoom Contact Center. Reprocess a failed or skipped recording to try importing it again, or skip a failed one to dismiss it."
    />
  );
};
